import React, { FC } from "react"

export const LandingPageEnhancementProcessDot: FC = () => {
  return <span className="bg-shade-800 border-2 border-solid border-white w-5 h-5 rounded-[50%] z-1" />
}
